/**
 * created by han guo qi
 * 新增视频弹窗
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FolderOpenOutlined,} from '@ant-design/icons';
import {
    Button,
    Input,
    Modal,
    Progress,
    Select,
    Tag,
    TreeSelect,
    Tabs,
    Slider,
    Icon,
    Dropdown,
    Menu,
    Tooltip, message, Spin
} from "antd";
import UploadWall from "../../../components/upload/UploadWall";
import {PIC_TYPE, VIDEO_TYPE, PIC_TYPE_ORIGINAL} from "../../../constants";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {TweenOneGroup} from "rc-tween-one";
import PreviewComponent from "./previewComponent";
import UploadPreviewImage from "../mediaJump/imageRelease/components/uploadPreviewImage/UploadPreviewImage";
import ImgUpload
    from "../../sysManagement/paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
import Titlepicfile from "../../components/titlepicfile/Titlepicfile";
import UploadVideo from "../quickHand/uploadVideo/uploadVideo";
import {getImgByVideo, permissionCheck, uuid} from "../../../utils";
import BaseComponent from "../../../base/BaseComponent";
import videojs from "video.js";
import "video.js/dist/video-js.css";
import playPic from '../image/sanjiaoxing.png'
import {rmtMessage} from "../components/mess"
import moment from "moment";
import {Scrollbars} from "react-custom-scrollbars";
import UploadImage from "../components/uploadImage/uploadImage"
import weChatIcon from "../image/wechaticon.png";
import MedialSelect from "../../editor/toolsSpace/tools/components/medialSelect";
import CurrencyResourceDialog from "../../resource/view/dialog/CurrencyResourceDialog";
import SecurityCheck, {
    addContentSecurityByText,
    removeColorByInheritCheck,
    formatItem,
    removeContentSecurity
} from "../component/securityCheck/securityCheck";
import RmtTextArea from "../component/rmtTextArea/rmtTextArea";
import $ from "jquery"
// import {configMedia} from "./config-media";

const {TextArea} = Input;
const {SHOW_CHILD} = TreeSelect;
const {TabPane} = Tabs;
const colors = ["#FCAA2F", "#2db7f5", "#87d068", "#108ee9"];
const checkColor = "#FF0000"; // 检测敏感词颜色
class KuaishouEditPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tags: [],
            inputVisible: false,
            inputValue: '',
            body: {
                id: '',
                coverUrl: "",
                mediaId: "",
                title: "",
                videoDuration: 0,
                videoFileLen: 0,
                videoUrl: "",
                tags: [],
                videoName: "",
                imgName:""
            },
            editData: {
                ico: {
                    value: '',
                    placeholder: "选择上传图标"
                },
            },//封面弹框中上传封面
            title: "",
            visible: false,
            disabled: false,
            editCoverModalVisible: false,//视频帧封面弹框
            uploadPictureVisible: false,//上传图片封面弹框
            selectedTab: '1',
            uploadVideoKey: uuid(),
            accountInformation: "",
            num:0,
            videoOption: {
                autoplay: false,//播放器准备好之后，是否自动播放 【默认false】
                loop: false, //视频播放结束后，是否循环播放
                controls: true,
                responsive: true,
                fluid: true,
                muted: false,//是否静音
                width: 480,
                height: 270,
                crossOrigin: 'anonymous',
                controlBar: {
                    fullscreenToggle: false,//显示全屏按钮，默认为true
                    pictureInPictureToggle: true,//隐藏画中画按钮，默认为true
                    volumePanel: true,//隐藏声音面板
                    currentTimeDisplay: true,//显示当前播放时间
                    timeDivider: false,//显示时间分割线
                    durationDisplay: true,//显示总时间
                    remainingTimeDisplay: true,//隐藏剩余时间，
                    audioTrackButton: true //音频跟踪按钮
                },
                sources: [{
                    src: '',
                    type: 'video/mp4'
                }
                ],
                playbackRates: [0.5, 1, 1.5, 2],
                aspectRatio: '16:9'
            },
            videoImg: '',
            currentTime: 1,//视频取桢数
            url: {},//发布和暂存的url,
            newEditWidth: 480,//等比缩放编辑图的宽高
            newEditHeight: 270,
            uploadFileList: [],//上传封面图的数据
            uploadImage: uuid(),
            treeData: [],//同步发布其他平台下拉数据
            mediaTypeCode: "",//确定是抖音还是快手
            treeSelectValue: "",//同步发布选择的内容
            isHover: "none",//鼠标移入移出事件
            checkedData: [],
            changeVideoImgStatus: "over",// 视频图片截取状态
        }
    }
    checkData = {}; // 检测敏感词数据

    componentDidMount() {
        this.setState({
            url: this.props.url,
            id: ""
        })
        // this.state.url = this.props.EditPageProps.url;
    }

    newBody = {};
    show = ({body, title, accountInformation, type, treeData, treeSelectValue, mediaTypeCode,id,mediaName}) => {
        this.newBody = JSON.parse(JSON.stringify(body));
        this.state.titleModal = title;
        this.state.accountInformation = accountInformation;
        this.state.body = body;
        if (body.statusName === '发布' || body.statusName === '已发布' || body.statusName == "正在发布") {
            this.state.disabled = true;
        } else {
            this.state.disabled = false;
        }
        this.setState({
            id,
            mediaName,
            visible: true,
            treeSelectValue: treeSelectValue,
            treeData: treeData,
            modalType: type,
            mediaTypeCode: mediaTypeCode
        })
    };

    hide = () => {
        this.setState({visible: false})
    };
    //点击发布,保存同步发布其他平台记录
    saveSynchronization = (body) => {
        // console.log('树', body);
        this.request({
            url: '/cm-sites-pms/releaseOtherPlatforms/saveRecord',
            body,
            method: 'post',
            callBack: (res) => {
                console.log(111, res)
            }
        })
    };

    initVideo() {
        let that = this;
        if (!this.player && this.state.body.videoUrl) {
            this.state.videoOption.sources[0].src = this.state.body.videoUrl;
            //创建视频区域
            this.player = videojs(that.videoNode, that.state.videoOption, function onPlayerReady() {
                console.log('onPlayerReady', this);
                that.setState({});
            });
        }
        if (this.player && this.state.videoOption.sources[0].src != this.state.body.videoUrl) {
            this.state.videoOption.sources[0].src = this.state.body.videoUrl;
            this.setState({}, () => {
                this.player.src({type: "video/mp4", src: this.state.videoOption.sources[0].src});
                this.player.load(this.state.videoOption.sources[0].src);
                this.player.pause();
                this.player = videojs(that.videoNode, that.state.videoOption, function onPlayerReady() {
                    console.log('onPlayerReady', this);
                    that.setState({});
                });
            })
        }
    };


    //修改弹框
    render (){
        let {visible, body, titleModal} = this.state;
        return (
            <div>
                <Modal
                    title={titleModal}
                    maskClosable={false}
                    centered
                    zIndex={700}
                    visible={visible}
                    onCancel={() => {
                        this.setState({visible: false});
                        this.props.onOkCall()
                    }}
                    keyboard={false}
                    width={1200}
                    style={{height: 718}}
                    footer={(body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布") ? null :
                        <div>
                            <Button onClick={() => {
                                this.setState({visible: false})
                                this.props.onOkCall()
                            }}>取消</Button>
                            <Button onClick={() => {
                                this.save({type: 'save'});
                            }} type="primary">暂存</Button>
                            <Button onClick={() => {
                                this.save({type:'publish'})
                            }} type="primary">发布</Button>
                        </div>}
                >
                    <div style={{height:575}}>
                        <div style={{display: "flex"}}>
                            {/*新增弹框左面部分*/}
                            {this.renderLeft()}
                            {/*新增弹框右面部分*/}
                            {this.renderRight()}
                        </div>
                        {this.renderEditCoverModal()}
                        {this.renderUploadPicture()}
                        <UploadVideo key={this.state.uploadVideoKey} ref={ref => this.uploadVideo = ref}/>
                    </div>
                </Modal>
                <SecurityCheck ref={ref=>this.securityCheck=ref}/>
            </div>
        )
    };
    //编辑封面
    editCover = (scr, name, call) => {
        if (scr) {
            window.edit.callback = function (obj) {
                call && call(obj.path)
            };
            window.edit.openEditPictureFrame(scr, name);
        } else {
            console.log("待编辑图片地址丢失")
        }
    };
    // 获取描述内容txt（带空格）
    getTitleText = () => {
        if($("#TextArea")?.[0]?.innerText) {
            return $("#TextArea")[0].innerText;
        }
        let title = this.state.body?.title?.length ? this.state.body.title : "";
        title = removeContentSecurity(title);
        title = title.replace(/<div><br><\/div>/g,"/n");
        title = title.replace(/<div>/g,"<div>/n");
        title = $(`<div>${title}</div>`).text();
        return title
    };
    // 获取描述内容html（无标记）
    getTitleHtml = () => {
        if($("#TextArea")?.html) {
            return removeContentSecurity($("#TextArea").html());
        }
        let title = this.state.body?.title?.length ? this.state.body.title : "";
        title = removeContentSecurity(title);
        title = $(`<div>${title}</div>`).html();
        return title
    };
    // 获取描述长度
    getTitleLength = () => {
        let {body} = this.state;
        let num = 0;
        let title = this.getTitleText();
        if(title.length &&(!body.tags||!body.tags.length)  ){
            num =  title.length + this.state.num
        }
        if(title.length &&body.tags&& body.tags.length){
            num =  title.length + this.state.num + body.tags.toString().length + 1 + body.tags.length
        }
        if(!title.length&&body.tags&& body.tags.length){
            num =  this.state.num + body.tags.toString().length + 1 + body.tags.length
        }
        if(!title.length &&(!body.tags||!body.tags.length)){
            num =  this.state.num
        }
        return num
    };
    //新增页面左边
    renderLeft = () => {
        let {visible, body, titleModal} = this.state;
        let {
            coverUrl = "",
            mediaId = "",
            videoDuration = 0,
            videoFileLen = 0,
            videoName = "",
            videoUrl = "",
            tags = [],
            title = ""
        } = body;
        let num =this.getTitleLength();
        return (
            <Scrollbars style={{height:575}}>
            <div>
                <div className={'left'} style={{width: 696}}>
                    {/*视频名和进度条*/}
                    <div style={{
                        height: 56,
                        backgroundColor: 'rgba(0,80,179,0.04)',
                        fontSize: '14px',
                        paddingTop: 12
                    }}>
                        <div style={{display: 'flex', justifyContent: 'space-between', paddingLeft: 24}}>
                            <div style={{
                                width: 102,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }} title={videoName}>{videoName}</div>
                            <div style={{display: 'flex', marginRight: 24}}>
                                <p style={{paddingRight: 24}}>大小:{" "}{this.bToMb(videoFileLen)}MB</p>
                                <p>视频时长:{" "}{this.timeCycle(videoDuration)}S</p>
                            </div>
                        </div>
                        {/*进度条*/}
                        <div style={{paddingLeft: 24, marginTop: -10}}>
                            {videoUrl ? <Progress strokeLinecap="square" percent={100} strokeColor={'blue'}/> : null}
                        </div>
                    </div>
                    {/*视频描述*/}
                    <div style={{paddingTop: 24}}>
                        <p style={{fontSize: '16px', fontWeight: 400, color: 'black'}}>
                            <span style={{color: "red"}}>*</span>
                            {" "}视频描述
                        </p>
                        <div>
                            {
                                this.renderCheckResult()
                            }
                        </div>
                        <div style={{width: 700, border: '1px solid rgba(0,80,179,0.08)'}}>
                            <Scrollbars autoHeight autoHeightMax={70}>
                                <RmtTextArea
                                    disabled={this.state.disabled}
                                    ref={ref=>this.rmtTextAreaRef = ref}
                                    // type={"text"}
                                    // onInput={(e)=>{
                                    //     // 监听到内容改变，改变敏感词检测状态
                                    //     console.log("onInput", e.target.innerText);
                                    //     this.state.body.title = e.target.innerText;
                                    //     this.setState({});
                                    //     this.onChangeByCheck();
                                    // }}
                                    onChange={(html)=>{
                                        console.log("onChange",html);
                                        const newHtml = removeColorByInheritCheck(this.rmtTextAreaRef.textAreaDivRef())(this.rmtTextAreaRef?.getContent);
                                        this.state.body.title = newHtml || html;
                                        this.setState({});
                                        this.onChangeByCheck();
                                    }}
                                    // onBlur={(e)=>{
                                    //     // 监听到拾取焦点，将文本数据存储
                                    //     console.log("onBlur", e.target.innerText);
                                    //     // let text = removeContentSecurity(e.target.innerText);
                                    //     this.state.body.title = e.target.innerText;
                                    //     this.setState({},()=>{
                                    //         console.log(this.state.body.title);
                                    //     })
                                    // }}
                                    style={{}}
                                    content={title}
                                />
                            </Scrollbars>
                            <div style={{
                                width: 700,
                                textAlign: "right",
                                boxSizing: "borderBox",
                                paddingRight: 20,
                                backgroundColor: 'rgba(0,80,179,0.04)'
                            }}>
                                <span>{num}</span>
                                <span>/</span>
                                <span>490</span>
                            </div>
                        </div>
                        {/*{this.renderTag(this.state.body.tags)}*/}
                        {/*{console.log(this.state.body.tags)}*/}
                        {/*{*/}
                        {/*    this.state.body.tags&&this.state.body.tags.length?this.renderTag(this.state.body.tags):null*/}
                        {/*}*/}

                    </div>
                    <div style={{display:'flex'}}>
                        <div style={{flex:1}}>
                            {
                                this.renderTag(this.state.body.tags)
                            }
                        </div>
                        <div>
                            {
                                this.renderCheck()
                            }
                        </div>
                    </div>
                    {/*视频封面*/}
                    <div style={{paddingTop: 54}}>
                        <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}><span
                            style={{color: "red"}}>*</span>{" "}视频封面</p>
                        <div style={{display: 'flex'}}>
                            {/*<img  style={{width: 88, height: 88,objectFit:'contain'}} src={coverUrl}/>*/}
                            {coverUrl ?
                                <Titlepicfile src={coverUrl} style={{
                                    width: 88,
                                    height: 88,
                                    border: "1px solid #E1EAF6",
                                    borderRadius: 2,
                                    background: "#F5F8FC"
                                }}>

                                </Titlepicfile> :
                                <div style={{
                                    width: 88,
                                    height: 88,
                                    border: "1px solid #E1EAF6",
                                    borderRadius: 2,
                                    background: "#F5F8FC",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-evenly",
                                    alignItems: "center"
                                }}
                                     onClick={
                                         () => {
                                             if (body.statusName !== "已发布") {
                                                 this.setState({uploadPictureVisible: true});
                                                 this.state.uploadImage = uuid();
                                             }
                                         }
                                     }
                                >
                                    <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                                    <div className="ant-upload-text">上传封面</div>
                                </div>
                            }
                            <div style={{paddingLeft: 24}}>
                                <p style={{fontSize: 12}}>
                                    请选择或者上传清晰美观的封面 <br/>
                                    如不上传封面,则使用<span>{this.state.mediaTypeCode == "kuaishou" ? "快手" : "抖音"}</span>默认设置的封面图
                                </p>
                                {body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布" ? null :
                                    <div style={{display: 'flex'}}>
                                        <p style={{width: 74.11, height: 22, color: '#0050B3', cursor: 'pointer'}}
                                           onClick={() => {
                                                        window.loading.show();
                                                       this.getVideoBase64(this.state.body.videoUrl).then(res => {
                                                           this.setState({videoImg: res,editCoverModalVisible: true},()=>{window.loading.hide();})
                                                       });
                                                       // this.equalScalingImg(this.state.body)
                                           }}>
                                            视频选封面
                                        </p>
                                        <p style={{
                                            width: 100,
                                            height: 22,
                                            color: '#0050B3',
                                            cursor: 'pointer',
                                            marginLeft: 10
                                        }}
                                           onClick={() => {
                                               this.setState({uploadPictureVisible: true});
                                               this.state.uploadImage = uuid()
                                           }}>
                                            上传图片封面
                                        </p>
                                        <p style={{
                                            width: 100,
                                            height: 22,
                                            color: '#0050B3',
                                            cursor: 'pointer',
                                            marginLeft: 10
                                        }}
                                           onClick={() => {
                                               if(!coverUrl){
                                                   rmtMessage.destroy();
                                                   rmtMessage.warning("请先选择一张封面图！")
                                               }
                                               this.editCover(coverUrl, "", (path) => {
                                                   this.state.body.coverUrl = path;
                                                   this.setState({});
                                               })

                                           }}
                                        >
                                            编辑封面
                                        </p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    {/*同步发布其他平台*/}
                    <div style={{padding: '24px 0px'}}>
                        <p style={{fontSize: '16px', fontWeight: 500, color: 'black'}}>同步发布其他平台</p>
                        <TreeSelect
                            treeDefaultExpandAll={true}
                            dropdownStyle={{maxHeight: 142, overflow: 'auto'}}
                            style={{width: 352}}
                            treeData={this.state.treeData}
                            value={this.state.treeSelectValue}
                            onChange={this.selectTree}
                            treeCheckable={true}
                            showCheckedStrategy={SHOW_CHILD}
                            searchPlaceholder='请输入'
                            showSearch={true}
                            multiple={true}
                            disabled={this.state.disabled}

                        />
                    </div>
                </div>
            </div>
            </Scrollbars>
        )
    };

    onChangeByCheck = () => {
        if(typeof this.securityCheck?.setCheckStatus === "function") {
            this.securityCheck.setCheckStatus("change",()=>{
                this.setState({})
            })
        }
    };

    renderCheckResult = () => {
        let render = "";
        let SENSITIVE = 0;
        let OUTSIDE_CHAIN = 0;
        let checkList = [];
        for(let i in this.checkData) {
            let item = this.checkData[i];
            if(item?.length) {
                for(let k=0;k<item.length;k++) {
                    let Item = item[k];
                    if(Item?.category === "OUTSIDE_CHAIN") {
                        OUTSIDE_CHAIN++
                    } else {
                        SENSITIVE++
                    }
                    checkList.push(formatItem(Item))
                }
            }
        }
        if(checkList?.length) {
            render = (
                <div style={{padding: "0px 0px 8px 0px"}}>
                    <div style={{
                        background: '#fff9f9',
                        border: '1px solid #fee',
                        height: 43,
                        lineHeight: '43px',
                        padding: '0 12px'
                    }}>检测到 敏感信息 <span style={{color: "red"}}>{SENSITIVE}</span> 条 疑似外链 <span
                        style={{color: "blue"}}>{OUTSIDE_CHAIN}</span> 条
                    </div>
                    <div style={{padding: "8px 8px 0px"}}>
                        <Scrollbars autoHeight autoHide autoHeightMax={120}>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                {checkList}
                            </div>
                        </Scrollbars>
                    </div>
                </div>
            )
        }
        return  render
    };

    renderCheck = () => {
        if(typeof this.securityCheck?.renderCheckBtn === "function") {
            let icon = this.securityCheck.renderCheckBtn({btnType:"icon"});
            let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
            let num = "";
            if(checkStatus === "over" && count > 0) {
                num = count > 9 ? "9+" : count
            }
            return (
                <Tooltip placement={"top"} title={(()=>{
                    switch (checkStatus) {
                        case "change" :
                            return "发现编辑器内容变化，请重新检测";
                        case "loading" :
                            return "检测中请稍后";
                        default :
                            return "单击开始内容检测"
                    }
                })()}>
                    <div
                        style={{position: "relative",cursor:"pointer", }}
                        onClick={()=>this.onCheckBtn()}
                    >
                        <img
                            style={{width:18}}
                            src={icon}
                        />
                        <span
                            style={{
                                position: "absolute",left:0,top:0,zIndex:998,
                                width: "100%",height: "100%",
                                textAlign: "center",lineHeight: "22px",
                                color:"#fff", fontSize:12,
                            }}
                        >{num}</span>
                    </div>
                </Tooltip>
            )
        } else {
            return ""
        }
    };
    // 给描述打敏感词标记
    setCheckTitle = () => {
        let title = this.getTitleHtml();
        if(this.checkData?.title?.length) {
            // 对敏感词进行排序，长的排前面
            this.checkData.title.sort((a,b)=>b.word.length-a.word.length);
            let newArr = [];
            this.checkData.title.forEach(item=>{
                if(newArr.every(Item=>Item.word!==item.word)) {
                    newArr.push(item)
                }
            });
            newArr.forEach(item=>{
                let replaceWord = addContentSecurityByText(item?.word);
                // let reg = `([>][^<]*)${item?.word}([^>]*[<])`;
                // title = title.replace(new RegExp(reg,"g"),`$1${replaceWord}$2`);
                title = this.checkWordReplace(title,item?.word,replaceWord);
            })
        }
        this.state.body.title = title
    };
    checkWordReplace = (content, word,replaceHtml) => {
        let newTxt = content;
        const regex = /(^|>)[^><]+?(?=$|<)/g;
        return  newTxt.replace(regex, (match) => {
            return match.replace(new RegExp(word,"g"), replaceHtml);
        });
    };
    onCheck = (call) => {
        message.destroy();
        if(!this.state.id) {
            message.warning("请先保存再检测");
            return false
        }
        if(typeof this.securityCheck.asyncCheck === "function") {
            this.getCheckData(({contents,data,key})=>{
                this.securityCheck.asyncCheck({contents,data,key,
                    call:(res)=>{
                        call&&call(res)
                    }
                });
            });
        } else {
            message.warning("敏感词检测失效，无法进行异步检测");
        }
    };

    onCheckBtn = () => {
        this.onCheck((res)=>{
            let msg = res?.msg;
            switch (res?.code) {
                case 0:
                    // 没有敏感词
                    message.success(msg || "未检测到敏感信息");
                    break;
                case 1:
                    // 检测到敏感词
                    message.warning(msg || "检测到敏感信息");
                    break;
                case -1:
                    // 检测报错
                    message.error(msg || "敏感词检测失败");
                    break;
                default:
                    // 未知错误
                    message.warning(msg || "敏感词检测失效，无法进行异步检测");
            }
            this.checkData = res.data;
            this.setCheckTitle();
            this.setState({});
        })
    };

    getCheckData = (call) => {
        let {body,id=""} = this.state;
        let title = this.getTitleText();
        if(!(title?.length)) {
            message.warning("请输入视频描述后再进行检测");
            return false
        }
        let data = {
            contents:{
                title: title,
                tags: body?.tags?.length ? body.tags.toString() : ""
            },
            data: {
                "id": id,
                "check_info_url": "/cm-sites-pms/kuaishou/getById?id="+id,
                "storyName": title,
                "storyStatusName": body.statusName || "",
                "mediaName": body.mediaName || this.state.mediaName,
                "createUserName": window.currentUser?.name || "",
                "deptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryUserName": body?.submitterName || window.currentUser?.name || "",
                "createStorydeptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryMediaName": body.mediaName || this.state.mediaName,
            },
            key: id || ""
        };
        call&&call(data)
    };

    //视频封面取桢
    getVideoBase64 = (url) => {
        let {currentTime, body} = this.state;
        let that = this;
        return new Promise(function (resolve, reject) {
            getImgByVideo({loading:false,url,second:currentTime,call:(img)=>{
                    resolve(img);
                }});
            return false;


            let dataURL = '';
            let video = document.createElement("video");
            video.setAttribute('crossorigin', 'anonymous'); //处理跨域
            video.setAttribute('src', url);
            video.setAttribute('width', body?.editWidth || 1920 );
            video.setAttribute('height', body?.editHeight || 1080);
            // video.setAttribute('controls', 'controls');
            video.currentTime = currentTime;  //视频时长，一定要设置，不然大概率白屏
            that.video = video;
            video.addEventListener('canplay', function (e) {
                console.log("video.videoWidth",video.videoWidth)
                console.log("video.videoHeight",video.videoHeight)
                let canvas = document.createElement("canvas"),
                    width = video.width, //canvas的尺寸和图片一样
                    height = video.height;
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
                dataURL = canvas.toDataURL('image/png'); //转换为base64
                var img = document.createElement("img");
                img.src = dataURL;
                video.setAttribute('poster', dataURL);
                resolve(dataURL);
            });
        })
    };

    getBlobBydataURI(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {type: type});
        // var formData = new FormData();
        // // var frameCurrentTime = videoFrameCollect.getFrameCurrentTime();
        // // var $Blob = getBlobBydataURI(videoFrameCollect.getFrameUrl(),'image/jpeg');
        // // var isDouyin = localStorage.getItem("isDouyin")
        // formData.append(dataURI);
    }

    //新增页面右边
    renderRight = () => {
        let {body, accountInformation, titleModal} = this.state;
        let {videoUrl, videoName} = body;
        let props = this.state.modalType == 'kuaishou' ? {
            weChatIcon,
            text: "微信"
        } : {};
        const menu = (
            <Menu>
                <Menu.Item>
                    <a style={{cursor: "pointer", textAlign: "left", alignItem: "center"}} onClick={() => {
                        this.uploadVideo.show(this.onUploadVideoCall);

                    }}>本地上传</a>
                </Menu.Item>
                {
                    permissionCheck('right_to_use_zyk')?<Menu.Item>
                        <a style={{cursor: "pointer", textAlign: "left", alignItem: "center"}} onClick={() => {
                            this.resourceDialog.show()
                        }}>资源库选择</a>
                    </Menu.Item>:null
                }
            </Menu>
        );
        return (
            <div>
                <div className={'right'} style={{
                    width: 384,
                    height: 575,
                    paddingTop: 15,
                    marginLeft: 40,
                    backgroundColor: 'rgba(0,80,179,0.04)'
                }}>
                    {/*预览组件*/}
                    <PreviewComponent getByIData={body} accountInformation={accountInformation} {...props} />
                    {
                        body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布" ? null :
                            <div style={{display: 'flex', justifyContent: 'center', paddingTop: '17px'}}>
                                <Dropdown overlay={menu}>
                                    <a type={'link'} style={{border: 'none', color: "#0050B3", fontSize: 14}}>重新上传</a>
                                </Dropdown>
                                <a type={'link'}
                                   style={{border: 'none', marginLeft: 32, color: "#0050B3", fontSize: 14}}
                                   onClick={() => {
                                       let that = this
                                       let name = "";
                                       window.editer.editSuccessCallBack = function (obj) {
                                           that.setState({
                                               body: {
                                                   ...that.state.body,
                                                   videoUrl: obj.path,
                                                   videoDuration: obj.duration,
                                                   videoName: obj.name,
                                                   editWidth:obj.width,
                                                   editHeight:obj.height

                                               },
                                               videoImg: obj.path
                                           })
                                       };
                                       window.editer.open(videoUrl, videoName);
                                   }}
                                >视频编辑</a>
                                <UploadVideo key={'uploadVideoKey'} ref={ref => this.uploadVideo = ref}/>
                                <CurrencyResourceDialog
                                    singleChoice = {true}
                                    onCallBackOk={(checkedData, call) => {
                                        if (checkedData.length != 1) {
                                            call && call(false);
                                            rmtMessage.warning("请选择一个视频！")
                                        } else {
                                            call && call(true);
                                            console.log(checkedData);
                                            this.setState({zykFileList: checkedData});
                                            let body = {
                                                coverUrl: checkedData[0].url,
                                                videoDuration: checkedData[0].duration,
                                                videoFileLen: checkedData[0].size,
                                                videoName: checkedData[0].name,
                                                videoUrl: checkedData[0].mp4Path,
                                                editWidth: checkedData[0].width,
                                                editHeight: checkedData[0].height
                                            };
                                            this.state.body = {...this.state.body, ...body};
                                        }
                                    }}
                                    indexName={"video"}
                                    ref={resourceDialog => this.resourceDialog = resourceDialog}/>

                            </div>
                    }
                </div>
            </div>
        )
    };
    // 本地上传和资源库视频选择,点击确定按钮回调
    onUploadVideoCall = (fileList) => {
        if (fileList.length > 1) {
            return rmtMessage.error('只能上传一个视频!')
        }
        if ((fileList[0].duration / 1000 / 60) > 15) {
            rmtMessage.error("不可发布超过15分钟的视频。");
            return false;
        }
        if (fileList[0].status === "uploading") {
            rmtMessage.warning("正在上传，请稍等。");
            return false;
        }
        if (fileList.length == 1) {
            let body = {
                // coverUrl: fileList[0].url,
                videoDuration: fileList[0].duration,
                videoFileLen: fileList[0].size,
                videoName: fileList[0].name,
                videoUrl: fileList[0].mp4Path,
                editWidth: fileList[0].width,
                editHeight: fileList[0].height,
                imgName:fileList[0].prefix
            };
            this.state.body = {...this.state.body, ...body};
        }
        this.uploadVideo.hide();
        this.setState({uploadVideoKey: uuid()});
    };


    bToMb = (size) => {
        if (size) {
            return (size / 1024 / 1024).toFixed(2)
        } else {
            return 0
        }
    };
    timeCycle = (time) => {
        if (time) {
            return time / 1000
        }
    }
    //修改弹框里的标签
    renderTag = (bodyTags) => {
        let newBodyTags = bodyTags;
        let {tags, inputVisible, inputValue, titleModal, body} = this.state;
        let tagChild = newBodyTags && newBodyTags.length ? newBodyTags.map(this.forMap) : tags.map(this.forMap);
        return (
            <div style={{position: 'relative', top: 0, width: 74.11, height: 22,}}>
                {!inputVisible && (
                    body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布" ? null :
                        <Tag onClick={this.showInput} style={{backgroundColor: 'white', marginTop: 4}}>
                            #添加话题
                        </Tag>
                )}
                {inputVisible && !(body.statusName === "发布" || body.statusName === "已发布" || body.statusName == "正在发布") && (
                    <Input
                        ref={this.saveInputRef}
                        type="text"
                        size="small"
                        style={{marginTop: 4}}
                        value={inputValue}
                        onChange={this.handleInputChange}
                        onBlur={this.handleInputConfirm}
                        onPressEnter={this.handleInputConfirm}

                    />
                )}

                <div>
                    <Scrollbars style={{position: 'absolute', left: (body.statusName === "发布" || body.statusName === "已发布") ? 0 : 80, top: 0, width: 585,}} autoHeight
                                autoHeightMax={80}>
                        <TweenOneGroup
                            enter={{
                                scale: 0.8,
                                opacity: 0,
                                type: 'from',
                                duration: 100,
                                onComplete: e => {
                                    e.target.style = '';
                                },
                            }}
                            leave={{opacity: 0, width: 0, scale: 0, duration: 200}}
                            appear={false}
                        >
                            {tagChild}
                        </TweenOneGroup>
                    </Scrollbars>
                </div>

            </div>
        )
    }
    //移除标签
    handleClose = removedTag => {
        const tags = this.state.body.tags.filter(tag => tag !== removedTag);
        this.state.body.tags = tags;
        this.onChangeByCheck();
        this.setState({tags});
    };
    //标签输入框
    showInput = () => {
        this.setState({inputVisible: true,}, () => this.input.focus());
    };
    handleInputChange = e => {
        let num = 0;
        if(e.target.value.length){
            num = e.target.value.length + 2;
        }else{
            num =0;
        }
        this.setState({inputValue: e.target.value,num:num},()=>{

        });
    };
    handleInputConfirm = () => {
        const {inputValue, body} = this.state;
        let title = this.getTitleText();
        let {tags} = this.state;
        if (inputValue && !(tags.indexOf(inputValue) === -1)) {
            this.setState({
                tags,
                inputVisible: false,
                inputValue: '',
            });
            rmtMessage.destroy();
            rmtMessage.warning("请勿输入同样的话题！");
            return;
        }
        if (inputValue && inputValue.length && tags.indexOf(inputValue) === -1) {
            tags = [...tags, inputValue];
        }
        if (body.tags && inputValue &&inputValue.length) {
            tags = [...body.tags, inputValue];
        }
        if(body.tags&&!inputValue.length){
            tags = [...body.tags];
        }
        if(title.length+ tags.toString().length +1 + tags.length >490){
            rmtMessage.destroy();
            rmtMessage.error('描述与话题总字数不能超过490！');
            return;
        }
        this.state.body.tags = tags;
        this.onChangeByCheck();
        this.setState({
            tags,
            inputVisible: false,
            inputValue: '',
            num:0
        },()=>{

        });
    };
    saveInputRef = input => (this.input = input);
    forMap = (tag, index) => {
        let newTag = '';
        if (tag.trim()) {
            newTag = tag.trim()
        } else {
            return false;
        }
        let color = colors[index % 4];
        if(this.checkData?.tags?.length) {
            if(this.checkData.tags.some(item=>newTag.indexOf(item?.word)>-1)) {
                color = checkColor
            }
        }
        if (newTag.length > 5) {
            newTag = newTag.substring(0, 5) + "...";
        }
        const tagElem =
            this.state.body.statusName == '已发布' ?
                <Tag
                    color={color}
                    style={{marginTop: 4}}
                >
                    {newTag}
                </Tag> :
                <Tag
                    closable
                    onClose={e => {
                        this.handleClose(tag);
                    }}
                    color={color}
                    style={{marginTop: 4}}
                >
                    {newTag}
                </Tag>


        return (
            <span key={tag} title={tag} style={{display: 'inline-block', zIndex: 999}}>
                {tagElem}
            </span>
        );
    };
    selectTree = (treeSelectValue) => {
        this.setState({treeSelectValue});
    };

    // 判定保存后是否需要检测敏感词
    checkActionDecision = (type) => {
        let needCheckStatus = this.sysConfigGetValueByKey("need.check.status.kuaishou","已发布");
        let status = "";
        if(type === "publish") {
            status = "已发布";
        } else if(type === "save") {
            status = "暂存";
        }
        return (needCheckStatus && ((status && needCheckStatus.indexOf(status) > -1) || needCheckStatus.indexOf("全部")>-1)) ? true : false
    };

    onCheckSave = (call,type) => {
        // 判定是否需要敏感词检测
        if(this.checkActionDecision(type)) {
            this.onCheck((res)=>{
                let msg = res?.msg;
                switch (res?.code) {
                    case 0:
                        // 没有敏感词
                        call&&call();
                        break;
                    case 1:
                        // 检测到敏感词
                        if(type === "publish") {
                            Modal.confirm({
                                title: "检测到视频描述含有敏感信息",
                                content: "建议返回修改",
                                cancelText: "全部忽略并继续",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{
                                    this.checkData = res.data;
                                    this.setCheckTitle();
                                    this.setState({});
                                },
                                onCancel: ()=>{
                                    call&&call()
                                },
                            });
                            return false
                        } else {
                            Modal.warning({
                                title: "检测到视频描述含有敏感信息",
                                content: "建议返回修改",
                                okText: "返回修改",
                                icon: "exclamation-circle",
                                centered:true,
                                onOk: ()=>{},
                            });
                        }
                        break;
                    case -1:
                        // 检测报错
                        message.error(msg || "敏感词检测失败");
                        break;
                    default:
                        // 未知错误
                        message.warning(msg || "敏感词检测失效，无法进行异步检测");
                }
                this.checkData = res.data;
                this.setCheckTitle();
                this.setState({});
            });
        } else {
            call&&call()
        }
    };

    save = ({type}) => {
        // let {getPageList}=this.props;
        let {url} = this.state;
        let body = this.checkForm();
        if (!body) return false;
        let newUrl = url["save"];
        this.request({
            url: newUrl,
            method: 'POST',
            body,
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    this.setState({id:res?.id,body:res},()=>{
                        this.onCheckSave(()=>{
                            if(type==="publish") {
                                this.publish(res)
                            } else {
                                rmtMessage.success('暂存成功！');
                                // this.hide();
                                if (typeof this.props.onOkCall == 'function') {
                                    this.props.onOkCall(false)
                                } else {
                                    // rmtMessage.error('暂存失败');
                                }
                            }
                            //保存同步发布其他平台记录
                            if (this.state.treeSelectValue&&this.state.treeSelectValue.length&&this.state.treeSelectValue.length !== 0) {
                                this.saveSynchronization({originId: res.id, mediaIds: this.state.treeSelectValue})
                            } else {
                                this.saveSynchronization({originId: res.id, mediaIds: ""})
                            }
                        },type);
                    });
                } else {
                    rmtMessage.error('暂存失败');
                }
            },
            errorCallBack: (e) => {
            },
        })
    };
    publish = (res)=>{
        let {url} = this.state;
        let newUrl = url["publish"];
        this.request({
            url: newUrl,
            method: 'POST',
            body:res,
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    rmtMessage.success('正在发布中，请稍后刷新列表查看！');
                    this.hide();
                    if (typeof this.props.onOkCall == 'function') {
                        this.props.onOkCall()
                    }
                } else {
                    rmtMessage.error('发布失败');
                }
            }
        })
    }

    checkForm = () => {
        // 必填项需要校验是否填了
        let title = this.getTitleText();
        let {body} = this.state;
        if (!(body && body.videoUrl)) {
            rmtMessage.warning('请上传视频！');
            return false
        }
        if (!(title?.length && title.trim()?.length)) {
            rmtMessage.warning('请填写视频描述！');
            return false
        }
        if(body.tags && body.tags.length){
            if(title.length + body.tags.toString().length +1+ body.tags.length >490){
                rmtMessage.warning('描述与话题总字数不能超过490！');
                return false
            }
        }
        if (!(body && body.coverUrl)) {
            rmtMessage.warning('请上传视频封面图！ ');
            return false
        }
        return {
            ...body,
            title
        }
    };

    //视频帧封面等比例缩放图片
    equalScalingImg = (body) => {
        let videoPicRatio = body.editWidth / body.editHeight;
        let newEditWidth;
        let newEditHeight;
        if (videoPicRatio < 1) {
            newEditWidth = 270 * videoPicRatio;
            newEditHeight = 480 * videoPicRatio;
        }
        if (videoPicRatio > 1) {
            newEditWidth = 480 / (videoPicRatio) * 1.5;
            newEditHeight = 270 / (videoPicRatio) * 1.5;
        }
        if (videoPicRatio === 1) {
            newEditWidth = 270;
            newEditHeight = 270
        }
        this.setState({
            newEditWidth, newEditHeight
        });
        this.state.body = {...this.state.body, ...body};
    };

    //视频帧封面弹框
    renderEditCoverModal = () => {
        let {editData, body, currentTime, newEditWidth, newEditHeight} = this.state;
        // console.log("videoImg    :",this.state.videoImg)
        return (
            <Modal
                title={"视频选封面"}
                maskClosable={false}
                centered
                visible={this.state.editCoverModalVisible}
                onOk={() => {
                    // body.coverUrl = [];
                    // let file = this.getBlobBydataURI(this.state.videoImg, 'image/jpeg');
                    // this.convertVideoPic(file);
                    //成功的回调，直接打开编辑封面弹窗
                    if (this.state.videoImg) {
                        this.editCover(this.state.videoImg, this.state.body.videoName.split(".")[0]+"-裁剪.png", (path) => {
                            this.state.body.coverUrl = path;
                            this.setState({});
                        });
                    }
                    this.setState({
                        editCoverModalVisible: false,
                    });
                }}
                onCancel={() => {
                    this.setState({
                        editCoverModalVisible: false,
                    })
                }}
                width={800}
                bodyStyle={{height: 345}}
                wrapClassName={'renderUpload'}
            >
                <div className="interval">
                    {/*<Tabs onChange={this.nativeBank}>*/}
                    {/*    <TabPane tab="视频选封面" key="1">*/}
                            <div style={{width: "100%", height: "100%", padding: '25px 0 40px',}}>
                                {
                                    !this.state.videoImg ? "" : (
                                        <Spin
                                            spinning={this.state.changeVideoImgStatus !== "over"}
                                        >
                                            <div style={{
                                                width: this.state.videoOption.width,
                                                height: this.state.videoOption.height,
                                                display: 'flex',
                                                margin: 'auto',
                                                background: 'black',

                                            }}>
                                                <div data-vjs-player
                                                     style={{
                                                         width: this.state.videoOption.width,
                                                         height: this.state.videoOption.height,
                                                         position: 'relative',
                                                         display: 'flex',
                                                         justifyContent: 'center',
                                                         alignItems: "center"
                                                     }}>
                                                    <video ref={node => this.videoNode = node} style={{margin: 'auto'}}
                                                           id='myVideo'
                                                           className="video-js vjs-big-play-centered">
                                                    </video>
                                                    <img src={this.state.videoImg} style={{
                                                        maxWidth: this.state.videoOption.width,
                                                        maxHeight: this.state.videoOption.height,
                                                        // width: newEditWidth,
                                                        // height: newEditHeight,
                                                        position: 'absolute',
                                                        objectFit: "contain",
                                                        // top: "0px",
                                                        // left: '0px',
                                                        // marginLeft: (480 - newEditWidth) / 2 + 'px',
                                                        // marginTop: (270 - newEditHeight) / 2 + 'px'
                                                    }}/>
                                                    {/*视频取桢进度条*/}
                                                    <div style={{
                                                        position: 'absolute',
                                                        left: 0,
                                                        bottom: 0,
                                                        width: 480,
                                                        height: 56,
                                                        background: 'rgba(0,0,0,0.45)'
                                                    }}>
                                                        <div style={{display: 'flex', paddingLeft: 23, paddingTop: 13}}>
                                                            {/*<img style={{width:9,height:13,paddingTop:5}} src={playPic}/>*/}
                                                            <p style={{
                                                                color: 'white',
                                                                fontSize: 12,
                                                                marginLeft: '-5px'
                                                            }}>视频截图截取</p>
                                                            <div style={{color: 'white', marginLeft: 275}}>
                                                                <span>{moment(currentTime * 1000).format('mm:ss')}</span>/<span>{moment(body.videoDuration).format('mm:ss')}</span>
                                                            </div>
                                                        </div>
                                                        <div style={{marginTop: -16}}>
                                                            <Slider
                                                                defaultValue={1}
                                                                style={{width: 448, marginLeft: 16}}
                                                                disabled={false}
                                                                max={this.timeCycle(body.videoDuration)}
                                                                min={1}
                                                                onAfterChange={(value) => {
                                                                    if (value <= 0) {
                                                                        return false;
                                                                    }
                                                                    this.setState({
                                                                        changeVideoImgStatus: "loading",
                                                                        currentTime: value
                                                                    }, () => {
                                                                        this.getVideoBase64(this.state.body.videoUrl).then(res => {
                                                                            this.setState({videoImg: res,changeVideoImgStatus: "over"})
                                                                        })
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<Titlepicfile src={this.state.videoImg} style={{position:'absolute',top:25,left:160,objectFit:"cover"}}/>*/}

                                            </div>
                                        </Spin>
                                    )
                                }
                            </div>
                        {/*</TabPane>*/}
                    {/*</Tabs>*/}
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>
            </Modal>
        )
    }
    //上传图片弹框
    renderUploadPicture = () => {
        let {editData, body, currentTime, uploadFileList} = this.state;
        const onDataChange = this.onDataChange;
        // 不需要上传的文件类型
        const excludeType = ["gif","GIF"];
        return (
            <Modal
                title={"上传图片封面"}
                maskClosable={false}
                centered
                zIndex={800}
                visible={this.state.uploadPictureVisible}
                onOk={() => {
                    let imgCoverSize =  this.bToMb(uploadFileList[0].size);
                    if(imgCoverSize && imgCoverSize > 10 ){
                        rmtMessage.error("封面图大小不能超过10M！");
                        return
                    }
                    body.coverUrl = uploadFileList.length === 1 ? uploadFileList[0].path : (body.coverUrl || this.newBody.coverUrl);
                    if (uploadFileList[0]?.status === "uploading") {
                        rmtMessage.warning("正在上传，请稍等。");
                        return false;
                    }
                    this.setState({
                        uploadPictureVisible: false,
                        uploadFileList: []
                    });
                    this.editCover(body.coverUrl, this.state.uploadFileList[0].name, (path) => {
                        this.state.body.coverUrl = path;
                        this.state.body.imgName = path;
                        this.setState({});

                    })
                }}
                onCancel={() => {
                    this.setState({
                        uploadPictureVisible: false,
                        uploadFileList: []
                    })
                }}
                width={800}
                bodyStyle={{height: 345}}
                wrapClassName={'renderUpload'}
            >
                <div className="interval">
                    {/*<Tabs onChange={this.nativeBank}>*/}
                    {/*    <TabPane tab="上传图片封面" key="1">*/}
                            <div style={{padding: 24}}>
                                {/*<ImgUpload*/}
                                {/*    placeholder={editData.ico.placeholder}*/}
                                {/*    onChange={ico => onDataChange({ico})}*/}
                                {/*    value={editData.ico.value}/>*/}
                                {/*<UploadPreviewImage*/}
                                {/*    placeholder={editData.ico.placeholder}*/}
                                {/*    onChange={ico => onDataChange({ico})}*/}
                                {/*    value={editData.ico.value}/>*/}
                                <UploadImage
                                    key={this.state.uploadImage}
                                    accept={"."+PIC_TYPE_ORIGINAL.filter(item=>!excludeType.includes(item)).join(",.")}
                                    beforeUpload={(file)=>{
                                        let fileName = file.name.split('.');
                                        let upload = fileName.at(-1).toUpperCase();
                                        upload = PIC_TYPE.filter(item=>!excludeType.includes(item)).includes(upload);
                                        let flag = true;
                                        if(file?.size > 10*1024*1024) {
                                            rmtMessage.error("封面图大小不能超过10M！");
                                            flag = false
                                        }
                                        if (!upload) {
                                            message.error('暂不支持该文件类型！');
                                            flag = false
                                        }
                                        return new Promise((resolve, reject) => {
                                            if (!flag) {
                                                reject(file);
                                            } else {
                                                resolve(file);
                                            }
                                        });
                                    }}
                                    onChange={(uploadFileList) => {
                                        // console.log(uploadFileList[0].path)
                                        this.setState({uploadFileList})
                                    }}/>
                            </div>
                        {/*</TabPane>*/}
                    {/*</Tabs>*/}
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>
            </Modal>
        )
    }
    //视频帧封面图接口
    convertVideoPic = (file) => {
        var formData = new FormData();

        formData.append('file', file, this.state.body.videoName.split(".")[0]+"-裁剪.png");
        // console.log(formData)
        this.request({
            url: "/storage/uploadFile",
            method: 'POST',
            body: formData,
            contentType: 'upload',
            callBack: (res) => {
                if (res) {
                    //成功的回调，直接打开编辑封面弹窗
                    if (res.path) {
                        this.editCover(res.path, this.state.body.videoName.split(".")[0]+"-裁剪.png", (path) => {
                            this.state.body.coverUrl = path;
                            this.setState({});
                        });
                    }
                }
            },
            errorCallBack: (e) => {
            },
        })
    }
    nativeBank = (activeKey) => {
        this.setState({
            selectedTab: activeKey,
        })
    }
    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };
}

KuaishouEditPage.propTypes = {};

export default KuaishouEditPage;
